/* eslint-disable @nx/enforce-module-boundaries */
import { useInfiniteQuery, useMutation } from '@tanstack/react-query';
import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import {
  createGlobalIndustries,
  getGlobalIndustries,
} from 'v4/store/actions/global.data.actions';

export const useIndustry = ({ search,enabled=true }) => {
  const dispatch = useDispatch();
  const tid = useRef(-1);

  useEffect(() => {
    // if (search?.length) {
      clearTimeout(tid.current);
      tid.current = setTimeout(() => {
        refetch?.();
      }, 300);
    // }
  }, [search]);
  const {
    mutateAsync,
    mutate,
    isLoading: createLoading,
  } = useMutation({
    mutationKey: ['global-industry-create'],
    mutationFn: async (payload) => {
      const resp = (await dispatch(createGlobalIndustries(payload)))?.payload;
      refetch?.();
      return resp;
    },
    onSuccess: () => {
      refetch();
    },
  });
  const {
    isLoading,
    isFetching,
    data = { pages: [] },
    fetchNextPage,
    refetch,
  } = useInfiniteQuery({
    queryKey: ['global-industry', search],
    queryFn: async () => {
      const resp = await dispatch(getGlobalIndustries({ search }));
      return resp?.payload;
    },
    getNextPageParam: (lastPage, pages) => {
      if (lastPage?.next) {
        const url = new URL(lastPage.next);
        const page = url.searchParams.get('page');
        return parseInt(page, 10);
      }
      return undefined;
    },
    refetchOnWindowFocus: false,
    enabled
  });


  return {
    isLoading: isFetching,
    createLoading,
    data,
    fetchNextPage,
    refetch,
    search,
    mutate,
    mutateAsync,
  };
};
